import React, { useState, useRef, useEffect } from "react";
import _ from '@lodash';
import { useDispatch } from 'react-redux';
import { AgGridReact } from 'ag-grid-react';
import '../../../../styles/ag-custom.css';
import useRouter from '@fuse/hooks/useRouter';
import axios from "@fuse/utils/axios";
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import 'styles/ag-grid-header-style.css';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import AgGridFilterGroupView from '@fuse/components/AgGridFilterGroupView';
import { convertToTimezone, handleFilterApplied } from "helper/common";
import { setfilterlist, setrowGroupModel } from '../store/filterParamsReducer';


function ListView(props) {
	const tabData = sessionStorage.getItem('tabValue')
	const [tabValue, setTabValue] = useState(Number(tabData) ?? 0)
	const router = useRouter();
	const gridRef = useRef();
	const dispatch = useDispatch();
	const [windowHeight, setWindowHeight] = useState(window.innerHeight - 290);
	const [groupByArr, setGroupByArr] = useState([])
	const [rowGroupPanelShow, setRowGroupPanelShow] = useState('never');
	const [update, setUpdate] = useState(0)
	const [onMounted, setOnMounted] = useState(false);
	const [filterText, setFilterText] = useState({
		tabValue: Number(tabData),
		text: ''
	});
	const skipHeader = [
		"id", "host_id", "created_at", "updated_at"
	]
	const frameworkComponents = {
		customFilter: CustomFilter,
	};
	const [filterApplied, setFilterApplied] = useState(false);
	const [filterData, setFilterData] = useState(JSON.parse(sessionStorage.getItem('redirectFilter')));
	const tableName = tabValue === 0 ? "UNRESOLVED_ALERT_END_USER" : "ALERT_END_USER";

	const tableHeaders = [
		"alert_id", "alert_subject", "company_name", "device_name", "serial_no", "location_name", "problem_time", "recovery_time",
		"event_duration", "event_status",
	];

	async function getIncidents(params) {
		try {
			const { startRow, endRow, filterModel, sortModel, rowGroupCols, groupKeys, pivotMode } = params.request;
			axios.post(`/zabbix/get-all-incident`, {
				dataSourceParams: {
					startRow, endRow, filterModel, sortModel, rowGroupCols, groupKeys, pivotMode
				},
				module: tabValue === 0 ? 'Unresolved Alert' : 'Alert'
			}).then((res) => {
					const rows = formatData(res.data.data.rows);
					const { lastRow } = res.data.data;
					(params.success || params.successCallback)?.({
						rowData: rows,
						rowCount: lastRow ?? rows.length,
					});
				if(rows.length === 0) gridRef.current.api.showNoRowsOverlay();
				else gridRef.current.api.hideOverlay();
				setOnMounted(true)
			}).catch((err) => {
				console.log('error', err)
				(params.fail || params.failCallback)?.();
			})
		} catch (err) {
			console.log(err);
		}
	}

	const handleChildClick = (value) => {
		setTabValue(value)
	};

	function formatData(data) {
		return data.map((item) => {
			return {
				alert_id: item.alert_id,
				serial_no: item.serial_no,
				device_name: item.device_name,
				event_severity: item.event_severity,
				problem_time: item.problem_time ? convertToTimezone(item.problem_time, 'date') : '',
				recovery_time: item.recovery_time ? convertToTimezone(item.recovery_time, 'date') : '',
				alert_subject: item.alert_subject,
				event_duration: item.event_duration,
				asset_id: item.asset_id || null,
				company_name: item.company_name || '',
				location_name: item?.location_name,
				event_status: item?.event_status
			}
		})
	}

	const onGridReady = (params) => {
		gridRef.current = params
		params.api.sizeColumnsToFit()
		if (router.query.report_name === undefined) {
			loadInitialState(params)
			dispatch(setfilterlist({}));
			dispatch(setrowGroupModel([]));
		}
		else {
			setRowGroupPanelShow('always')
			getReport(params);
		}
	}

	function onFilterChanged(event) {
		const rows = event.api.getFilterModel();
		gridRef.current = { ...gridRef.current, filterModelArr: rows }
		dispatch(setfilterlist(rows));
		saveView("N/A", rows, gridRef.current.filterModelArr)
		const totalRows = event.api.getDisplayedRowCount();

		if (totalRows === 0) {
			event.api.showNoRowsOverlay();
		} else {
			event.api.hideOverlay();
		}
	}

	function getReport(event) {
		const { reportName } = router.query;
		const tableNames = "alert";
		axios.get(`/reports/view-report?table_name=${tableNames}&report_name=${reportName}`)
			.then(results => {
				const model = JSON.parse(results.data.data.filter);
				event.api.setFilterModel(model);
				const rowModel = JSON.parse(results.data.data.row_model);
				event.api.setColumnState(rowModel);
				const dataSource = {
					getRows: async (param) => {
						getIncidents(param)
					}
				}
				event?.api.setGridOption('serverSideDatasource', dataSource);
			})
			.catch(err => {
				console.log(err);
			})
	}

	function loadInitialState(params) {
		const table_name = tabValue === 0 ? "UNRESOLVED_ALERT_END_USER" : "ALERT_END_USER";
		if (!table_name) return;
		axios.get(`/user-view/show-view-order?table_name=${table_name}`)
			.then(results => {
				const { data } = results.data;
				if (data !== null) {
					const order = JSON.parse(data.order);
					const filter = JSON.parse(data?.filter);
					if (Object.keys(filter || {})?.length) {
						setFilterApplied(true)
					}
					gridRef.current = { ...gridRef.current, filterModelArr: filter }

					// params?.api.applyColumnState({ state: order });
					params?.api.applyColumnState({ state: order });
					params.api.setFilterModel(filter);

					onMounted && setUpdate(update + 1)
				}
			})
			.catch(err => {
				console.log(err);
			}).finally(() => {
				const dataSource = {
					getRows: async (param) => {
						getIncidents(param)
					}
				}
				params?.api.setGridOption('serverSideDatasource', dataSource);
			})
	}

	const saveView = (rows, filter) => {
		if (!tableName) return;
		let payload = {}
		if (rows === 'N/A') {
			payload = {
				filter: JSON.stringify(filter),
				table_name: tableName
			}
		} else {
			payload = {
				order: JSON.stringify(rows),
				table_name: tableName
			}
		}
		axios.post('/user-view/save-view-order', payload)
			.then(() => {
				console.log('view updated')
			})
			.catch(err => {
				console.log(err);
			})
	}

	const onColumnMoved = (params) => {
		const rows = params.api.getColumnState();
		saveView(rows);
		dispatch(setrowGroupModel(rows))
	}

	function onColumnVisible(params) {
		const rows = params.api.getColumnState();
		const totalNoColumns = rows.length;
		let totalHiddenColumns = 0;
		rows.forEach(row => {
			const { hide } = row;
			if (hide) {
				totalHiddenColumns += 1;
			}
		});
		if (totalHiddenColumns < totalNoColumns) {
			saveView(params.api.getColumnState());
		}
	}

	function onColumnRowGroupChanged(event) {
		const { reportName } = router.query;
		if (reportName === undefined) {
			const rows = event.api.getColumnState();
			const firstRow = rows[1];
			if (firstRow.colId !== 'ag-Grid-AutoColumn') {
				saveView(rows);
				dispatch(setrowGroupModel([]));
			} else {
				dispatch(setrowGroupModel(rows));
			}
		}
		const api = event?.api;
		if (!api) return;
		const groupedColumns = api.getRowGroupColumns();
		if (groupedColumns.length === 0) setGroupByArr([]);
		else setGroupByArr(groupedColumns);
	}

	const onColumnPinned = (params) => {
		if (router.query.report_name === undefined) {
			const rows = params.api.getColumnState();
			saveView(rows);
		}
	}

	function redirectToAssetProfile(params) {
		if (!params.data.asset_id) return
		router.push(`/assets-list/${params.data.asset_id}`);
	}

	const generateHeaderLabel = (header) => {
		if (header === 'alert_id') {
			return 'Alert ID'
		} if (header === 'serial_no') {
			return 'Serial Number'
		} if (header === 'event_subject') {
			return 'Alert Description'
			// } if (header === 'event_status') {
			// 	return 'Status'
		} if (header === 'company_name') {
			return 'Client Name'
		}
		if (header === 'location_name') {
			return 'Location'
		}
		if (header === 'problem_time') {
			return 'Start Date & Time'
		}
		if (header === 'recovery_time') {
			return 'End Date & Time'
		}
		if (header === 'event_duration') {
			return 'Duration'
		}
		return header.split('_').map(word => {
			return word.charAt(0).toUpperCase() + word.substring(1)
		}).join(' ')
	}

	function onSortChanged(params) {
		const rows = params.api.getColumnState();
		if (router.query.report_name === undefined) {
			dispatch(setrowGroupModel(rows))
			saveView(rows);
		}
	}

	useEffect(() => {
		setTimeout(() => {
			const filterArray = filterData;
			if (filterArray && gridRef.current.api) {
				gridRef.current.api.hideOverlay();
				sessionStorage.removeItem("redirectFilter")
				handleFilterApplied(filterArray, gridRef.current?.api);
				setFilterData();
				sessionStorage.removeItem('tabValue')
				if (Object.keys(filterArray?.filterModel)?.length) {
					setFilterApplied(true)
					setFilterText({
						...filterText,
						text: `User is currently viewing the ${tableName === 'ALERT_END_USER' ? 'Alerts' : 'Unresolved Alerts'} page with the following filters…`
					});
					// setTableTitle('User is currently viewing the Assets page with the following filters…')
				}

				setUpdate(update + 1)
			}
		}, 1000)
	}, [gridRef.current?.api])

	const clearRedirectionFilter = () => {
		setFilterApplied(false);
		setFilterText()
	}

	return (
		<>
			<AgGridFilterGroupView
				tableRef={gridRef}
				setRowGroupPanelShow={setRowGroupPanelShow}
				groupByArrFromList={groupByArr}
				displayTableName={tabValue === 0 ? "Unresolved Alert List" : "All Alert List"}
				onClick={handleChildClick}
				tableIndex={tabValue}
				tableName="Alert List"
				clearRedirectionFilter={clearRedirectionFilter}
				key={update}
			/>
			<div
				className="ag-theme-alpine"
				style={{
					width: "100%",
					height: windowHeight + 105,
					fontSize: '11px'
				}}
			>
				{(filterApplied && filterText?.tabValue === tabValue) && <p style={{ margin: '4px' }}>{filterText?.text ?? "Filters have been applied"}</p>}
				<AgGridReact
					ref={gridRef}
                    theme="legacy"
					onGridReady={onGridReady}
					animateRows
					rowHeight={30}
                    headerHeight={44}
					rowModelType='serverSide'
					serverSideStoreType="partial"
					key={tabValue}
					defaultColDef={{
						enableRowGroup: true,
						sortable: true,
						resizable: true,
						filter: true,
					}}
					defaultExcelExportParams={{
						sheetName: 'Dalos-Source'
					}}
					pagination
					overlayNoRowsTemplate="<span>No Result Found</span>"
					showOpenedGroup
					suppressDragLeaveHidesColumns
					suppressMakeColumnVisibleAfterUnGroup
					rowGroupPanelShow={rowGroupPanelShow}
					onColumnMoved={onColumnMoved}
					onColumnPinned={onColumnPinned}
					onColumnVisible={(data) => onColumnVisible(data)}
					groupHeaderHeight={1}
					components={frameworkComponents}
					floatingFiltersHeight={40}
					onSortChanged={(params) => onSortChanged(params)}
					onFilterChanged={(params) => onFilterChanged(params)}
					onColumnRowGroupChanged={(event) => onColumnRowGroupChanged(event)}
					columnDefs={tableHeaders.filter((item) => !skipHeader.includes(item)).map((header) => {
						return {
							key: header,
							field: header,
							headerName: generateHeaderLabel(header),
							sortable: true,
							filter: "agTextColumnFilter",
							type: ['problem_time', 'recovery_time'].includes(header) ? 'agDateColumnFilter' : 'agTextColumnFilter',
							flex: 1,
							minWidth: 260,
							headerComponent: (ele) => (CustomFilter(ele, header, gridRef)),
							cellRenderer: (event) => {
								if (event.colDef.field === "alert_id") {
									return (<a
										style={{
											height: '10px',
											width: '10px',
											color: 'black',
											cursor: 'pointer',
											marginTop: '2px',
											borderRadius: '50%',
											// display: 'inline-block',
											display: 'flex',
											alignItems: 'center',
											gap: '10px'
										}}
										onClick={() => redirectToAssetProfile(event)}
									>
										<span>{event.value}</span>
									</a>)
								}
								return (<span>{event.value}</span>)
							}
						}
					})}
				 />
			</div>
		</>
	);
}

export default ListView
